import { $$, on, doc } from './util.js';

/* 7. FAQ ACCORDION (FRD 6.6) */
export function initFaq() {
	$$('.faq-q').forEach(function (q) {
		on(q, 'click', function () {
			var open = q.getAttribute('aria-expanded') === 'true';
			var panel = doc.getElementById(q.getAttribute('aria-controls'));
			q.setAttribute('aria-expanded', open ? 'false' : 'true');
			if (panel) { panel.hidden = open; }
		});
	});
}
